import { takeLatest, call, put } from "redux-saga/effects";
import axios from "axios";

export function* watcherSendNotificationEmail() {
  yield takeLatest("SEND_NOTIFICATION_EMAIL_REQUEST", sendNotificationEmail);
}

function fetchSendNotificationEmail(formData) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_URI_SERVER}/api/Public/Seguros/SendNotificationEmail`,
    data: formData,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

function* sendNotificationEmail(action) {
  try {
    const response = yield call(fetchSendNotificationEmail, action.payload);
    yield put({ type: "SEND_NOTIFICATION_EMAIL_SUCCESS", data: response.data });
  } catch (error) {
    yield put({ type: "SEND_NOTIFICATION_EMAIL_FAILURE", error: error.response?.data || error.message });
  }
} 